(function(root){
  'use strict';
  const rules=typeof module!=='undefined'&&module.exports?require('./ridek-sun-rules.js'):root.RidekSunRules;
  const ATTRIBUTE='ridek_sun_prototype_requested';
  const id=value=>String(value||'').split('/').pop();
  const isSun=item=>id(item.product_id)===rules.SUN_PRODUCT||id(item.variant_id)===rules.SUN_VARIANT;
  const managed=item=>isSun(item)&&item.properties?._ridek_sun_offer==='first-free';
  function activationWindow(time){const start=Date.parse(time);return Number.isFinite(start)?{startsAt:new Date(start).toISOString(),endsAt:new Date(start+168*60*60*1000).toISOString()}:null;}
  function normalize(cart){return (cart.items||[]).map(item=>({productId:item.product_id,variantId:item.variant_id,title:item.product_title||item.title||'',quantity:item.quantity,isGiftCard:item.gift_card===true,netCents:item.final_line_price}));}
  function distributionAllowed(config,now){const start=Date.parse(config.startsAt),end=Date.parse(config.endsAt);return config.distributionEnabled===true&&config.nativeDiscountConfigured===true&&config.productAvailable===true&&config.inventoryConfirmed===true&&Number.isFinite(start)&&end-start===337*60*60*1000&&now>=start&&now<end;}
  function describe(cart,optional,active,quantity){
    const lines=normalize(cart),actualQty=(cart.items||[]).filter(isSun).reduce((n,i)=>n+i.quantity,0);
    const chosen=typeof optional==='boolean'?optional:actualQty>0;
    const intended=rules.evaluate(lines,chosen,true,quantity??(actualQty||1));
    const actual=rules.evaluate(lines,chosen,active,actualQty||1);
    // Prevent a checked free selection silently becoming a $4 charge when another discount wins.
    if(active&&intended.requested&&actualQty&&actual.sunCents>Math.max(0,actualQty-1)*400){actual.blocked=true;actual.reason='The free Sun discount has not applied. Please remove the Sun or adjust your discount before checkout.';}
    return {cart,requested:intended.requested,intended,actual,active,changed:false,checkboxEligible:intended.checkboxEligible};
  }
  function createSync(transport,config,now=()=>Date.now()){
    let tail=Promise.resolve();
    async function run(optional,quantity){
      let cart=await transport.read(),changed=false,note='';
      const active=distributionAllowed(config,now());
      if(!active)return describe(cart,optional,false,quantity);
      const initial=describe(cart,optional,true,quantity);
      const gifts=cart.items.filter(isSun),owned=gifts.filter(managed);
      const removing=optional===false||!initial.checkboxEligible;
      const toRemove=optional===false?gifts:owned;
      if(removing&&toRemove.length){
        for(const line of toRemove)await transport.change({id:line.key,quantity:0});
        changed=true;
        if(optional!==false)note='Sun selection removed because this cart no longer qualifies. Your other items are unchanged.';
      }else if(initial.requested){
        const wanted=Number.isSafeInteger(quantity)&&quantity>0?quantity:Math.max(1,initial.actual.sunQuantity);
        if(!gifts.length){await transport.add({items:[{id:Number(rules.SUN_VARIANT),quantity:wanted,properties:{_ridek_sun_offer:'first-free'}}]});changed=true;}
        else if(quantity!==undefined){
          // One canonical line for this opt-in; explicitly preserve separately added retail lines.
          const line=owned[0]||gifts[0];
          if(gifts.length===1&&line.quantity!==wanted){await transport.change({id:line.key,quantity:wanted});changed=true;}
        }
      }
      if(changed)cart=await transport.read();
      const state=describe(cart,removing?false:undefined,true);
      const attr=state.requested?'yes':'';
      if((cart.attributes?.[ATTRIBUTE]||'')!==attr){await transport.update({attributes:{[ATTRIBUTE]:attr}});cart=await transport.read();changed=true;}
      return {...describe(cart,removing?false:undefined,true),changed,note};
    }
    return {sync(optional,quantity){const job=tail.catch(()=>{}).then(()=>run(optional,quantity));tail=job;return job;}};
  }
  const api=Object.freeze({ATTRIBUTE,normalize,describe,activationWindow,distributionAllowed,createSync});
  if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.RidekSunCart=api;
})(typeof window==='undefined'?this:window);

